// extracted by mini-css-extract-plugin
module.exports = {"Section":"layout-module--Section--1kZmj","Container":"layout-module--Container--3ebR1"};